import type {TariffsZones} from '../../api'
import type {Path, PathWithCountry} from '../../types'

// true если нету country или один из сегментов country | city не валидный
export function shouldRedirect(zones: TariffsZones, path: Path) {
  const {country} = path

  if (!country || !(country in zones)) {
    return true
  }

  return false
}

export const isPathWithCountry = (path: Path): path is PathWithCountry => Boolean(path.country)
